import axios from 'axios'
import { Message, Loading} from 'element-ui'

const service = axios.create({
    baseURL: 'https://api.ifurniture.co.nz/', // api的base_url
    // baseURL: 'https://localhost:44327/', // api的base_url
    timeout: 30000 // 请求超时时间
  })
  
  let loadingInstance
  
  // request拦截器
  service.interceptors.request.use(
    config => {
      loadingInstance = Loading.service({
        lock: true,
        text: 'Working out the quotation...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      }) 
      return config
    },
      error => {
        // Do something with request error
        loadingInstance.close()
        Message.error('Sorry there was something wrong. Please try again or contact us')
        console.log(error) // for debug
        Promise.reject(error)
      }
  )

  // respone拦截器
service.interceptors.response.use(
    response => {
      if (response.status === 200) {
        setTimeout(()=>{
          loadingInstance.close()
        },1000)
       
        return response
      } else {
        setTimeout(()=>{
          loadingInstance.close()
        },1000)
        // Message.error(res.data.msg)
      }
      return response
    },
    error => {
      // console.log('err' + error.response.Error) // for debug
      // setTimeout(()=>{
      //   loadingInstance.close()
      // },1000)
      Message({
        message: 'Failed to get data',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  )
  
  export default service





// WEBPACK FOOTER //
// ./src/api/request.js